import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { fetchFromAPI } from '../utils/fetchFromAPI'
import { ChannelCard, Videos } from './index'

const ChannelDetail = () => {
  const [channelDetail, setChannelDetail] = useState(null)
  const [videos, setVideos] = useState([])

  const { id } = useParams()
  // console.log(videos, channelDetail)
  useEffect(() => {
    fetchFromAPI(`channels?part=snippet&id=${id}`)
      .then((data) => setChannelDetail(data?.items[0]))

    fetchFromAPI(`search?channelId=${id}&part=snippet&order=date`)
      .then((data) => setVideos(data?.items))
  }, [id])

  return (
    <Box sx={{ minHeight: '95vh'}}>
      <Box>
        <div style={{
          background: 'linear-gradient(90deg, rgba(50,140,252,1) 0%, rgba(242,5,239,1) 100%)',
          zIndex: 10,
          height: '300px'
        }} />

        <ChannelCard channelDetail={channelDetail} marginTop='-92px' />
      </Box>

      <Box display='flex' p={2} >
        <Box sx={{ mr: { sm: '100px' } }} />
          <Videos videos={videos} />
      </Box>
    </Box>
  )
}

export default ChannelDetail